import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const features = [
    {
      icon: 'Shield',
      text: 'Bank-level encryption',
    },
    {
      icon: 'Lock',
      text: 'Secure data storage',
    },
    {
      icon: 'FileCheck',
      text: 'Complete audit trails',
    },
  ];

  return (
    <div className="bg-muted/50 rounded-md p-4 border border-border">
      <div className="flex items-center gap-2 mb-3">
        <Icon name="ShieldCheck" size={20} color="var(--color-success)" />
        <span className="text-sm font-medium text-foreground">Your data is protected</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-center gap-2">
            <Icon name={feature?.icon} size={16} className="text-success" />
            <span className="text-xs text-muted-foreground">{feature?.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityFeatures;